module.exports = __webpack_public_path__ + "img/tilstand_hymo_kvalitetselement.28435582.jpg";